<div class="loader" *ngIf="isOpen">
  <mat-spinner></mat-spinner>
</div>
